import React from 'react';
import { Select, Input } from 'antd';

const { Option } = Select;

export function KeySelector({ selected, handleChange }) {
  return (
    <Select value={selected} style={{ width: 100 }} onChange={handleChange}>
      <Option value="/">Trends</Option>
      <Option value="/noc">Realtime</Option>
    </Select>
  );
}

export function ProductSelector({ selected, handleChange }) {
  return (
    <Select value={selected} style={{ width: 200 }} onChange={handleChange}>
      <Option value={1}>Experience Insights</Option>
      <Option value={5}>Ad Insights</Option>
    </Select>
  );
}

export function UsernameInput({ selected, handleChange, handleSearch }) {
  return (
    <Input
      style={{ width: 200 }}
      placeholder="Enter username"
      value={selected}
      onChange={handleChange}
      onPressEnter={handleSearch}
      allowClear
      required
    />
  );
}
